import {
  IntegrationsMarketplaceAppContainerController
} from '../controller/IntegrationsMarketplaceAppContainerController';
import {BaseWebComponentElement} from '../../../framework/BaseWebComponentElement';

export class IntegrationsMarketplaceAppContainerWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationsMarketplaceAppContainerController,
    });

  }
}
